import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";
import {DigitalInStatus} from "./digitalInStatus";
import {UrlBuilder} from "../url-builder/url.builder";


@Injectable({
  providedIn: 'root'
})
export class DigitalInStatusDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<DigitalInStatus> {
    this.uiUrl = this.url.GetDigitalInStatusUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<DigitalInStatus>(this.uiUrl);
  }

}


